import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Group, Modal, Stack, Text,Textarea } from "@mantine/core";

import { showLoadingNotification, showSuccessNotification } from "@utils/showNotification";

import { useCancelAppointment } from "@hooks/mutations/appointment/useCancelAppointment";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface CancelAppointmentModalProps {
  opened: boolean;
  close: () => void;
  appointmentId: string;
}

export const CancelAppointmentModal = ({ opened, close, appointmentId }: CancelAppointmentModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const { mutate: cancelAppointment, isLoading } = useCancelAppointment();
  const handleErrors = useQueryErrorHandling();

  const handleCancel = () => {
    const id = showLoadingNotification({});
    cancelAppointment(
      { appointmentId, cancellationReason: reason },
      {
        onSuccess: () => {
          showSuccessNotification({
            id,
            title: "success",
            message: "cancel-appointment-success",
          });
          close();
          setReason("");
        },
        onError: (res: any) => {
          handleErrors(res, "mutation", id);
        },
      }
    );
  };

  return (
    <Modal opened={opened} onClose={close} title={t("cancel-appointment")} centered>
      <Stack>
        <Text size="sm">{t("cancel-selected-appointment")}</Text>
        <Textarea
          label={t("reason-for-cancellation")}
          placeholder={t("type-reason")}
          value={reason}
          onChange={(event) => setReason(event.currentTarget.value)}
          minRows={3}
        />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={close} disabled={isLoading}>
            {t("cancel")}
          </Button>
          <Button color="red" onClick={handleCancel} loading={isLoading} disabled={!reason.trim()}>
            {t("confirm")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
